// extracted by mini-css-extract-plugin
export var classContainer = "ProductStickyNav-module--classContainer--b804b";
export var hidden = "ProductStickyNav-module--hidden--82dbb";
export var price = "ProductStickyNav-module--price--86e1c";
export var wrapper = "ProductStickyNav-module--wrapper--92de7";